import React from 'react'
import BaseEducationTab from './BaseEducationTab'

export default function AdditionalEducation() {
  return <BaseEducationTab tabType="additionalEducation" />
}
